import { useContext } from 'react';

import { createSelectedHook } from '@core/utils/createSelectedHook';
import { DrawingShapeContext } from '@ee-context';
import { selectUserSelectedEdge } from '@redux/slices/edgeSlice';

import { useEdges } from '../useEdges';

export const _useSelectedEdge = createSelectedHook({
    selector: selectUserSelectedEdge,
    apiQueryHook: useEdges,
    shouldReturnDefault: ({ selectedValue, apiHookResponse }) => {
        return (
            !selectedValue || !apiHookResponse.sortedEdges.some((edge) => edge.productId === selectedValue?.productId)
        );
    },
    selectDefaultValue: ({ apiHookResponse }) => apiHookResponse.sortedEdges[0],
});

export const useSelectedEdge = () => {
    const { selectedValue, ...rest } = _useSelectedEdge();
    const { sortedEdges: edges } = useEdges();
    const { activeDrawingShape } = useContext(DrawingShapeContext);
    const activeDrawingEdge = edges.find((dShape) => dShape.productId === activeDrawingShape?.edge?.productId);
    return { ...rest, selectedValue: activeDrawingEdge ?? selectedValue };
};
